module.exports = __webpack_public_path__ + "img/pic_bb_new.5d4b4e9e.png";